<template>
  <div v-if="summary" class="resume-banner">
    <span class="resume-text">
      Unfinished upload — <strong>{{ summary.projectName }}</strong>
      ({{ summary.doneFiles }}/{{ summary.totalFiles }} uploaded)
      <template v-if="summary.source === 'server'">— from another session</template>
    </span>
    <span class="resume-actions">
      <button class="resume-btn resume-btn-primary" @click="resume">Resume</button>
      <button class="resume-btn resume-btn-outline" @click="discard">Discard</button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'UploadResumeBanner',
  computed: {
    summary: function () { return this.$store.getters['uploadDrafts/SUMMARY'] }
  },
  methods: {
    resume: function () {
      var query = this.summary.source === 'server'
        ? { resumeServerDraft: this.summary.projectSlug }
        : { resumeDraft: this.summary.draftId }
      this.$router.push({ path: '/mix', query: query })
    },
    discard: function () {
      this.$store.dispatch('uploadDrafts/DISCARD')
    }
  }
}
</script>

<style lang="scss" scoped>
.resume-banner {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 8px 20px;
  background: rgba(201,168,76,0.1);
  border-bottom: 1px solid rgba(201,168,76,0.2);
  backdrop-filter: blur(10px);
}

.resume-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  color: var(--gold-mid);

  strong {
    color: var(--gold-bright);
    font-weight: 600;
  }
}

.resume-actions {
  display: flex;
  gap: 8px;
}

.resume-btn {
  font-family: 'Montserrat', sans-serif;
  font-size: 9px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  border-radius: 2rem;
  padding: 5px 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid rgba(201,168,76,0.3);
  background: transparent;
  color: var(--gold-mid);

  &:hover { border-color: var(--gold-mid); }
}

.resume-btn-primary {
  background: rgba(201,168,76,0.15);
  &:hover { background: var(--gold-deep); color: #fff; }
}
</style>
